import type { AIRequest, AIResponse, APIError, HealthCheckResponse } from '@/types/api';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://us-central1-dairy-translate.cloudfunctions.net';

class APIService {
  async callAI(request: AIRequest, authToken?: string): Promise<AIResponse> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/askAI`, {
        method: 'POST',
        headers,
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        const errorData: APIError = await response.json().catch(() => ({
          error: `HTTP error! status: ${response.status}`
        }));
        
        if (response.status === 403 && errorData.code === 'RATE_LIMIT_EXCEEDED') {
          throw new Error('RATE_LIMIT_EXCEEDED');
        }
        
        throw new Error(errorData.error || 'API request failed');
      }

      return await response.json();
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Network error occurred');
    }
  }

  async healthCheck(): Promise<HealthCheckResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      return await response.json();
    } catch (error) {
      console.error('Health check failed:', error);
      return { 
        status: 'error', 
        timestamp: new Date().toISOString(),
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }
}

export const apiService = new APIService();